// unfortunately required for react-pdf to work on older browsers
// copied from https://github.com/ungap/with-resolvers/blob/main/index.js
Promise.withResolvers ||
  (Promise.withResolvers = function withResolvers() {
    var a,
      b,
      c = new this(function (resolve, reject) {
        a = resolve
        b = reject
      })
    return { resolve: a, reject: b, promise: c }
  })

// required for hasOwn to work on older browsers - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwn
// copied from https://github.com/tc39/proposal-accessible-object-hasownproperty/blob/main/polyfill.js
if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value: function (object, property) {
      if (object == null) {
        throw new TypeError('Cannot convert undefined or null to object')
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property)
    },
    configurable: true,
    enumerable: false,
    writable: true,
  })
}
